module.exports = "/components/components/managerBlocksNavigationComponent-7508eb.html";